// 反查+电话拨打(外包暂时没有拨打)
<template>
<!-- 虚拟号码展示+打电话 -->
  <span v-if="isVirtualNumber">
    <span
      v-if="!eyesNumber"
      class="virtualNumber-btn"
      @click="getByEyesReverse('',true)"
    >点击查看虚拟号</span>
    <span v-else>{{eyesNumber}}</span>
    <!-- 拨打电话组件 -->
    <!-- <breathe-btn
      style="margin-left:10px"
      v-if="eyesNumber&&eyesNumber!=='--'&&hasBreatheBtn"
      :callParams="{ waybillNo: paramsData.waybillNo, workOrderNo: paramsData.workOrderNo, telB: eyesNumber }"
    /> -->
  </span>
  <!-- 收寄件号码展示+打电话 -->
  <span v-else>
    <span>
      <span v-if="isChecked">{{eyesNumber||'--'}}</span>
      <span v-else>{{paramsData.phone||'--'}}</span>
    </span>
    <!-- 拨打电话组件 -->
    <!-- <breathe-btn
      style="margin-left:10px"
      v-if="hasBreatheBtn&&paramsData.phone"
      :callParams="{
        waybillNo: paramsData.waybillNo,
        workOrderNo: paramsData.workOrderNo,
        telB:eyesNumber
      }"
      :beforeCall="getByEyesReverse"
    /> -->
    <i
      v-if="paramsData.phone&&hasEyes&&!isChecked"
      class="iconfont iconfuwuzhiliang-mingwen"
      @click="getByEyesReverse(true)"
    />
  </span>
</template>

<script>
import { RESPONSE_CODE } from '@public/http/config'
import { detailView } from '@/components/pool'

export default {
  props: {
    paramsData: {
      default: () => {
        return {
          phone: '', // 加密号码
          waybillNo: '', // 运单号
          queryType: 1// 1:寄件 2：收件 3:虚拟号
        }
      },
      type: Object
    },
    hasBreatheBtn: Boolean, // 是否展示电话组件
    hasEyes: { // 是否展示小眼睛
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isChecked: false, // 是否已经点击过小眼睛
      eyesNumber: '' // 反查后号码
    }
  },
  watch: {
    'paramsData.waybillNo': {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.isChecked = false
          this.eyesNumber = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isVirtualNumber() {
      return this.paramsData.queryType === 3
    }
  },
  methods: {
    // 点击小眼睛反查收寄件人
    // isEyes:区分点击小眼睛/电话  isVirtual:虚拟号
    async getByEyesReverse(isEyes, isVirtual) {
      if (this.eyesNumber && !isVirtual) return (this.isChecked = true)
      const params = {
        ...this.paramsData,
        waybillId: this.paramsData.waybillNo,
        queryReason: 'KFLD'
      }
      const { code, data, msg } = await detailView.reqOrderInfoPlaintext(params)
      if (code === RESPONSE_CODE.SUCCESS) {
        isEyes === true && (this.isChecked = !this.isChecked)
        const { receiverMobilePhone, senderMobilePhone, receiverTelphone, senderTelphone, virtualNumber } = data || {}
        if (this.paramsData.queryType === 1) {
          // 寄件
          this.eyesNumber = senderMobilePhone || senderTelphone
        } else if (this.paramsData.queryType === 2) {
          // 收件
          this.eyesNumber = receiverMobilePhone || receiverTelphone
        } else {
          // 虚拟号
          this.eyesNumber = virtualNumber || '--'
        }
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.iconfuwuzhiliang-mingwen {
  cursor: pointer;
  margin-left: 10px;
  color: #e60012;
  font-size: 18px;
}
.virtualNumber-btn {
  color:#338fe5;
  cursor: pointer;
}
</style>
